// extracted by mini-css-extract-plugin
module.exports = {"container":"profile-image-ProfileImage-container-016c6588","badge":"profile-image-ProfileImage-badge-433ac4b0"};